// import { messageLog } from './message-logger';

export type algoliaConfigProps = {
  searchIndex?: string;
  hitsPerPage?: number;
};

export const algoliaDefaultConfig: Required<algoliaConfigProps> = {
  searchIndex: 'prod_index',
  hitsPerPage: 10,
};

// const getAlgoliaConfigObj = (defaultConfig: Required<algoliaConfigProps>): Required<algoliaConfigProps> => {
//   const algoliaSSIConfig: algoliaConfigProps = window.algoliaConfig ?? {};
//   return { ...defaultConfig, ...algoliaSSIConfig };
// };

// export const buildAlgoliaConfig = (): void => {
//   /** Do not log datadog if in dev build and no userToken */
//   const algoliaConfig = getAlgoliaConfigObj(algoliaDefaultConfig);
//   window.algoliaConfig = algoliaConfig;
//   messageLog.info('AlgoliaConfig:', ['searchIndex', algoliaConfig]);
// };
